import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import MainContent from "./mainContent";
import { useParams, useNavigate } from "react-router-dom";
import { getChangeRequestDetails } from "../../api/casp/changeRequest";
import { toast } from "react-toastify";
import Loader from "../../Components/Common/Loader";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Button from "@mui/material/Button";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import CommentModal from "../../Components/casp/common/CommentModal";
import { ApprovalStatuses, ChangeRequestStatus } from "../../constants/Status";
import { ApprovalModule, Modules } from "../../constants/Module";
import { updateApprovalStatus } from "../../api/casp/approval";
import { useSelector } from "react-redux";
import { ChangeRequestStatusColor } from "../../constants/ChangeRequestStatus";
import DescriptionIcon from "@mui/icons-material/Description";
import ShowCommentModal from "../../Components/casp/common/ShowCommentModal";
import { Helmet } from 'react-helmet';
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import { getIconPath } from "../../helpers/file_helper";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { withTranslation } from "react-i18next";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ContentInfo from "../../common/contentInfo";

function ViewChangeRequest(props) {
  const [changeRequestDetails, setChangeRequestDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { changeRequest } = useParams();
  const [openCommentModel, setOpenCommentModel] = useState(false);
  const [openRejectModel, setOpenRejectModel] = useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const navigate = useNavigate();
  const [rejectReason, setRejectReason] = useState();
  const { project } = useParams()

  useEffect(() => {
    if (changeRequest) {
      fetchChangeRequestDetails();
    }
  }, []);

  const fetchChangeRequestDetails = async () => {
    try {
      setIsLoading(true);
      const res = await getChangeRequestDetails(changeRequest, {projectId: parseInt(project)});
      console.log('response', res.data.data)
      setChangeRequestDetails(res.data.data);
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleApproval = async (status, comments) => {
    try {
      const payload = {
        module: ApprovalModule.CHANGE_REQUEST,
        moduleId: changeRequestDetails.id,
        projectId: changeRequestDetails.projectId,
        status,
      };

      if (status === ApprovalStatuses.REJECTED) {
        payload.comments = comments;
      }

      const res = await updateApprovalStatus(
        changeRequestDetails.latestApproval.id,
        payload
      );

      if (status === ApprovalStatuses.APPROVED) {
        toast.success(res.data.message);
      }

      if (status === ApprovalStatuses.REJECTED) {
        toast.info(res.data.message);
        handleRejectModal();
      }
      navigate(`/project/${changeRequestDetails.projectId}/change-request-approval`);
    } catch (errors) {
      toast.error("Something went wrong.");
    }
  };

  const handleRejectCommentModal = () => {
    setOpenCommentModel(!openCommentModel);
  };

  const handleOpen = (comment, data) => {
    setOpenRejectModel(true);
    setRejectReason({
      name: data?.name,
      profilePicture: data?.profilePicture,
      role:data?.projectUsers[0]?.role?.name ?? '',
      comment,
    });
  };

  const handleRejectModal = () => {
    setOpenRejectModel(!openRejectModel);
    setRejectReason()
  };

  const handleBackClick = () => {
    navigate(-1); //navigate to back page
  };

  return (
    <React.Fragment>
      <div className="page-content change-req-pg position-relative">
        <Helmet
          onChangeClientState={(newState, addedTags) => {
            try {
              const newFaviconElems = filter(get(newState, 'linkTags', []), {
                rel: 'icon',
              })

              if (!newFaviconElems.length) {
                return
              }

              const newFaviconHref =
                newFaviconElems[newFaviconElems.length - 1].href

              const existingFavicons = document.querySelectorAll(
                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
              )

              if (existingFavicons.length) {
                existingFavicons.forEach(e => e.parentNode.removeChild(e))
              }

              const newFaviconElem = document.querySelector(
                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
              )

              if (newFaviconElem) {
                const newFavElement = newFaviconElem.cloneNode(true)
                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<PublishedWithChangesIcon />)}</svg>`
                )}`
                const parentElem = newFaviconElem.parentNode
                parentElem.removeChild(newFaviconElem)
                parentElem.appendChild(newFavElement)
              }
            } catch (e) {
              console.error(e)
            }
          }}
        >
          <title>{props.t("View Change Request")}</title>
        </Helmet>
        <Container fluid>
          <div className="mainPageHeader d-flex justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <ArrowBackOutlinedIcon className="me-2 cursor-pointer" onClick={handleBackClick} />
              <BreadCrumb title={props.t("View Details")} />
            </div>
            {changeRequestDetails && (
              <div className="projApprovalActions d-flex justify-content-center align-items-center">
                <div className={`statusBadge ${ChangeRequestStatusColor(changeRequestDetails?.status)} badge-outlined text-capitalize mx-1`}>
                  {changeRequestDetails.status === ChangeRequestStatus.IN_APPROVAL ? 'pending' : changeRequestDetails?.status}
                  {changeRequestDetails.status === ChangeRequestStatus.IN_APPROVAL &&
                    <ContentInfo content={changeRequestDetails?.latestApproval?.currentApprovalUser}/>
                  }
                  {changeRequestDetails.status ===
                    ChangeRequestStatus.REJECTED && (
                    <DescriptionIcon
                      style={{ cursor: "pointer", height:'18px' }}
                      onClick={() =>
                        handleOpen(
                          changeRequestDetails.previousApproval?.comments,
                          changeRequestDetails.previousApproval
                            ?.currentApprovalUser?.user
                        )
                      }
                    />
                  )}
                </div>
                {loggedInUser.id ===
              changeRequestDetails?.latestApproval?.currentApprovalUser
                .userId && (
              <div className="projApprovalActions">
                <Button
                  disableElevation
                  variant="contained"
                  className="approveBtn mx-2"
                  onClick={() => handleApproval(ApprovalStatuses.APPROVED)}
                >
                  <DoneIcon />
                  {props.t("Approve")}
                </Button>
                <Button
                  disableElevation
                  variant="contained"
                  color="error"
                  className="rejectBtn"
                  onClick={handleRejectCommentModal}
                >
                  <ClearIcon />
                  {props.t("Reject")}
                </Button>
              </div>
            )}
              </div>
            )}
            
          </div>
          <div className="project_select_name w-100">
            {changeRequestDetails && (
              <MainContent changeRequestDetails={changeRequestDetails} />
            )}

            {isLoading && <Loader />}
          </div>
        </Container>
      </div>

      <div className="rejectModal">
        <CommentModal
          handleRejectModal={handleRejectCommentModal}
          open={openCommentModel}
          handleApproval={handleApproval}
          module={'change request'}
        />

        <ShowCommentModal
          handleRejectModal={handleRejectModal}
          open={openRejectModel}
          module={Modules.CHANGE_REQUEST}
          data={rejectReason}
        />
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(ViewChangeRequest);
